import React, { ReactNode, ReactElement } from 'react';
import { Modal } from 'flowbite-react';
import { FaTimes } from 'react-icons/fa';
import { position } from 'html2canvas/dist/types/css/property-descriptors/position';

interface CustomModalProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  dismissible: boolean;
  show: boolean;
  icon: any;
  size?: string;
  onClose: () => void;
  childrenProps?: Record<string, any>;
  position?:string
}

const CustomModal = ({
  title,
  subtitle,
  icon,
  children,
  dismissible,
  show,
  size,
  onClose,
  childrenProps,
  position
}: CustomModalProps) => {
  const clonedChildren = React.Children.map(children, (child) =>
    React.isValidElement(child) ? React.cloneElement(child as ReactElement, childrenProps) : child
  );

  return (
    <Modal dismissible={dismissible} show={show} position={position} onClose={onClose} size={size}>
      <div className='py-4 px-6 mb-4 max-h-[80vh] overflow-y-auto'>
        <div className='flex justify-end  hover:cursor-pointer' onClick={onClose} onTouchStart={onClose}>
          <FaTimes />
        </div>
        <div>
          {clonedChildren}
        </div>
        {/* </Modal.Body> */}
      </div>

    </Modal>
  );
};

export default CustomModal;
